// import { configureStore } from "@reduxjs/toolkit";
// import providerNavigationReducer from "../Providers/components/provider-navbar/slice/providerNavigationSlice";
// import providerListingReducer from "../Providers/components/provider-listing/slice/listingSlice";
// import providerTicketReducer from "../Providers/components/provider-tickets/slice/providerTicketSlice";
// import authProviderReducer from "../Providers/components/auth-provider/slice/providerAuth";
// import providerChatReducer from "../Providers/components/provider-chat/slice/providerChatSlice";
// import providerChatListReducer from "../Providers/components/provider-chatList/slice/providerChatListSlice";
// import providerInfoData from "../Providers/components/provider-panel/slice/providerPanelSlice";
// import providerServiceData from "../Providers/components/provider-panel/slice/providerPanelServiceSlice";
// import providerImagesData from "../Providers/components/provider-panel/slice/providerPanelImageSlice";
// import providerVideosData from "../Providers/components/provider-panel/slice/providerPanelVideoSlice";
// import providerAppointmentData from "../Providers/components/provider-panel/slice/providerPanelAppointmentSlice";
// import providerWorktimeData from "../Providers/components/provider-panel/slice/providerPanelWorktimeSlice";

// import clientNavigationReducer from "../Clients/components/client-navbar/slice/clientNavigationSlice";
// import clientListingReducer from "../Clients/components/client-listing/slice/clientListingSlice";
// import clientTicketReducer from "../Clients/components/client-tickets/slice/clientTicketSlice";
// import authClientReducer from "../Clients/components/auth-client/slice/clientAuth";
// import clientChatReducer from "../Clients/components/client-chat/slice/clientChatSlice";
// import ClientChatListReducer from "../Clients/components/client-chatList/slice/clientChatListSlice";
// import ClientServicesReducer from "../Clients/components/client-services/slice/clientServicesSlice";
// import ClientServiceDetailsReducer from "../Clients/components/client-service-details/slice/clientServiceDetailsSlice";

// import userListingReducer from "../User/components/user-listing/slice/userListingSlice";

// const store = configureStore({
//   reducer: {
//     providerNavigation: providerNavigationReducer,
//     providerList: providerListingReducer,
//     providerTickets: providerTicketReducer,
//     providerChat: providerChatReducer,
//     providerChatList: providerChatListReducer,
//     providerAuth: authProviderReducer,
//     providerInfo: providerInfoData,
//     providerService: providerServiceData,
//     providerImages: providerImagesData,
//     providerVideos: providerVideosData,
//     providerAppointments: providerAppointmentData,
//     providerWorktime: providerWorktimeData,

//     clientList: clientListingReducer,
//     clientAuth: authClientReducer,
//     clientNavigation: clientNavigationReducer,
//     clientTickets: clientTicketReducer,
//     clientChat: clientChatReducer,
//     clientChatList: ClientChatListReducer,
//     clientServices: ClientServicesReducer,
//     clientServiceDetails: ClientServiceDetailsReducer,

//     userList: userListingReducer,
//   },
// });

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

const store = configureStore({
  reducer: rootReducer,
});

export default store;